// Shipping fee logic shared between CartPage and CheckoutPage.
// Free shipping kicks in when the cart subtotal reaches the threshold;
// below that we charge a flat fee.

export const FREE_SHIPPING_THRESHOLD = 5000;
export const FLAT_SHIPPING_FEE = 199;

export interface FreeShippingState {
  /** True when subtotal has met or exceeded the threshold. */
  reached: boolean;
  /** Rupees remaining to qualify. 0 when reached. */
  remaining: number;
  /** Integer 0–100 — how full the progress bar is. */
  pct: number;
}

export function freeShippingState(subtotal: number): FreeShippingState {
  const reached = subtotal >= FREE_SHIPPING_THRESHOLD;
  return {
    reached,
    remaining: reached ? 0 : FREE_SHIPPING_THRESHOLD - subtotal,
    pct: Math.min(100, Math.round((subtotal / FREE_SHIPPING_THRESHOLD) * 100)),
  };
}

export function shippingFee(subtotal: number): number {
  return subtotal >= FREE_SHIPPING_THRESHOLD ? 0 : FLAT_SHIPPING_FEE;
}
